
import { CORE_AXIOS, type Http } from "@/core"
import { container } from "tsyringe"

export const refundCreate = async (id: number, data: any): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.post(`/v1/api/oms/order/${id}/refund`, data)
}

export const refundDelete = async (id: number): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.delete(`/v1/api/oms/order/refund/${id}`)
}

export const refundUpdate = async (id: number, data): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.put(`/v1/api/oms/order/refund/${id}`, data)
}
export const refundChange = async (id: number, data): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.put(`/v1/api/oms/order/refund/withdraw/${id}`, data)
}

export const getExpress = async (): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.get("/v1/api/pdm/express/companies")
}

export const receivedOrder = async (id: number, data: object): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.put(`/v1/api/oms/order/deliver/${id}`, data)
}
